import React, { FC } from 'react';

interface Props {
  width?: string;
  height?: string;
  color?: string;
  title?: string;
  className?: string;
  fill?: string;
}

const IconPerson: FC<Props> = ({
  width = '16',
  height = '16',
  color = 'var(--color-white)',
  title = '',
  className = '',
  fill = 'transparent',
}) => {
  return (
    <svg
      width={width}
      height={height}
      stroke={color}
      fill={fill}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.6497 12.514C4.22985 11.6209 6.0554 11.1111 8 11.1111C9.94461 11.1111 11.7702 11.6209 13.3503 12.514M10.3333 6.44444C10.3333 7.73311 9.28866 8.77778 8 8.77778C6.71134 8.77778 5.66667 7.73311 5.66667 6.44444C5.66667 5.15578 6.71134 4.11111 8 4.11111C9.28866 4.11111 10.3333 5.15578 10.3333 6.44444ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {title && <title>{title}</title>}
    </svg>
  );
};

export default IconPerson;
